import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { positions, Provider, } from "react-alert";
import DefaultAlertTemplate from "./DefaultAlertTemplate";
const AlertProvider = ({ template = DefaultAlertTemplate, position = positions.BOTTOM_CENTER, timeout = 5000, offset = "0px", containerStyle = {
    marginBottom: "40px",
    zIndex: 101,
}, children, ...rest }) => {
    return (_jsx(Provider, { template: template, position: position, timeout: timeout, offset: offset, containerStyle: containerStyle, ...rest, children: children }));
};
export default AlertProvider;
